import React from "react";
import { getInlineImage } from "../../../API/api";

export default function Content({ text }) {
  const [data, setData] = React.useState("");
  const infuseImage = (text) => {
    const pattern =
      /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(?:_\d+)?/g;
    const inline = text.match(pattern) || [];
    console.log(inline)
    if (inline.length > 0) {
      getInlineImage(inline).then((res) => {
        Object.keys(res.data.data).forEach((key) => {
          text = text.replace(key, `<img src="${res.data.data[key]}" style='width:50%;height:auto' />`);
        });
        setData(text);
      });
    }else{
      setData(text);
    }
  };
  // React.useEffect(() => {
  //   infuseImage(text);
  // }, [text]);
  return <div dangerouslySetInnerHTML={{ __html: data.length > 0 ? data : text }}></div>;
}
